import memoizee from 'memoizee'
import moment from 'moment'
import { dropTimeZoneFromDate } from 'shared/libraries/utils/date'
import {
  changeTimezone,
  simplerGetTimeOfDayFromDate,
} from '../../shared/libraries/utils/date'

/**
 * NOTE: Copied from oppizi-api/src/libraries/utils/date
 * Get the week number e.g first new week in Jan is 1, last week in December
 * is 52.
 * Taken and modified from https://stackoverflow.com/a/6117889/837649
 * @param {Date} d
 * @returns {number} 1 to 53
 */
export const getWeekNumber = memoizee(d => {
  return moment(d).isoWeek()
})

/**
 * NOTE: Copied from oppizi-api/src/libraries/utils/date
 * Converts 1 to W01 and 30 to W30
 * @param {num}
 * @returns {string}
 */
export const formatWeekNumber = memoizee(num => {
  num = num + ''
  if (num.length === 1) num = '0' + num
  return 'W' + num
})

/**
 * Given a iso date with a timezone, this will simply drop the timezone off the
 * end so that if you instanciate it with `new Date(dateStr)` it won't do any
 * timezone manipulation and you'll have a date object that's local to that
 * timezone. Will return the same date if it is missing timezone
 * @returns {string}
 */
export const processDate = date => {
  try {
    const result = dropTimeZoneFromDate(date)
    return result
  } catch (e) {
    return date
  }
}

export const getCurrentTimeOfDay = ({
  afternoonCheckInTime,
  lunchCheckInTime,
  timezone,
}) => {
  if (!afternoonCheckInTime || !lunchCheckInTime || !timezone) {
    return
  }
  const date = new Date().toISOString()
  const dateStr = changeTimezone(date, timezone)
  const dropTimezone = dropTimeZoneFromDate(dateStr)
  return simplerGetTimeOfDayFromDate(dropTimezone, {
    afternoonCheckInTime,
    lunchCheckInTime,
  })
}



// WEBPACK FOOTER //
// ./src/Utils/Date/index.js